import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItineraryContentBlockSingleImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }
  }

  handleButtonTracking = () => {
    trackTravelPlannerInteraction(this.props.tabToggle, "button_click", { button_text: this.props.block.buttonText })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)

    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__single-image">
        <div className="grid">
          <div className="grid-item col--12 col-sm--4">
            <div className="foto-container">
              <div className="no-foto">
                <img src={this.props.block.image} alt={this.props.block.imageAltText} />
              </div>
            </div>
          </div>
          <div className="grid-item col--12 col-sm--8 left-align">
            <div className="textbuttoncontainer">
              <div className="info-text rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></div>
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.buttonLink}
                    onClick={() => this.handleButtonTracking()}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
